//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/Builder.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
let d=[[[0,"BreakInterpartExpression",1,0],[0,"BreakWaveLink",1,0],[0,"FaceCurveDirectionAdjustment",1,0],[0,"IncludeNonBrokenWaveLinks",1,0],[0,"IncludeSuppressedComponents",1,0],[0,"RelinkCategory",1,0],[0,"RelinkOption",1,0],[0,"RelinkType",1,0],[0,"SearchExistingInterPartExpressionOnly",1,0],[0,"SearchingDestinationObject",1,0],[0,"SearchingSourceObject",1,0],[0,"SearchingSourcePart",1,0],[0,"SearchingSourcePartAttribute",1,0],[1,"SelectComponent",0,"Assemblies.SelectComponentList",0],[1,"SelectComponentSource",0,"Assemblies.SelectComponentList",0],[0,"SourceScope",1,0],[0,"TargetScope",1,0]],[[[],"ExecuteRelink",{},0,0],[[],"SearchWavelinksInterpartExpressions",{},0,0],[[],"ExportToInformationWindow",{},0,0],[[],"UpdateSession",{},0,0],[[],"UpdateSessionWithBreakDelayed",{},0,0],[[],"ViewFeatureFailure",{},0,0],[["partID","expID","sourceID"],"GetExpressionSourceCount",{R_:{iSourceCount:''}},3,0],[["partID","expID","sourceID"],"RelinkInterpartExpression",{},3,0],[["partID","featID","sourceID"],"RelinkWaveFeature",{},3,0]],[]];
SPLM.Assemblies.RelinkerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.RelinkerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Assemblies.RelinkerBuilder.LinkScope = Object.freeze({
    "PartsInSession" : "PartsInSession", "PartsInAssembly" : "PartsInAssembly", "WorkPart" : "WorkPart", "SelectedParts" : "SelectedParts"});

SPLM.Assemblies.RelinkerBuilder.LinkCategory = Object.freeze({
    "WaveGeometry" : "WaveGeometry", "InterpartExpression" : "InterpartExpression"});

SPLM.Assemblies.RelinkerBuilder.LinkType = Object.freeze({
    "All" : "All", "NotBroken" : "NotBroken", "Broken" : "Broken", "AutoLinked" : "AutoLinked", "WithMultipleSource" : "WithMultipleSource"});

SPLM.Assemblies.RelinkerBuilder.LinkOption = Object.freeze({
    "InterpartExpression" : "InterpartExpression", "WaveGeometry" : "WaveGeometry", "Both" : "Both"});

export default SPLM;